import React from "react"
import  {Link,useHistory,useLocation, useParams}  from 'react-router-dom'
import styled from "styled-components"
import {useSelector} from "react-redux"
import {useAuth} from "../other/auth"


const Nav = styled.nav`
height: 3rem;
background-color: var(--first-color);
border-bottom: 1px solid #000;
`;

const ContainerButton = styled.div`
position:absolute;
right:2rem;
top:.5rem;
display: flex;

& > a{
    color: #fff;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    text-transform: uppercase;
    display: flex;
    background: #829196;
    height: 2rem;
    width: 11rem;
    // border-radius: 50%;
    border-radius:5px;
}

`

const CategoryButton = styled(Link)`
margin-right: 1rem;
&::after {
    width: 11rem;
    overflow:hidden;
    white-space: nowrap;
    border-radius:5px;
    text-decoration: none;
    color: #fff;
    padding-left:0.3rem;
    padding-right:0.3rem;
    content: 'Select category';
}
&:hover {
    border: 3px solid #ec1650
}
&:focus {
    border: 3px solid #ec1650
}
`
// &:hover {
//     width: 11rem;
//     -webkit-transition: width 1s;
//     transition: width .5s;
//     overflow:hidden;
//     white-space: nowrap;
//     border-radius:5px;
//     text-decoration: none;
//     color: #fff;
//     padding-left:0.3rem;
//     padding-right:0.3rem;
//   }

// &:hover::after {
//     padding-left:0.3rem;
//     padding-right:0.3rem;
//     content: 'Select category abc';
// }
// `

const EPGButton = styled(Link)`
margin-right: 1rem;
&::after {
    width: 8rem;
    overflow:hidden;
    white-space: nowrap;
    border-radius:5px;
    text-decoration: none;
    color: #fff;
    padding-left:0.3rem;
    padding-right:0.3rem;
    content: 'TV Guide';
}
`
// &:hover {
//     width: 8rem;
//     -webkit-transition: width 1s;
//     transition: width .5s;
//     overflow:hidden;
//     white-space: nowrap;
//     border-radius:5px;
//     text-decoration: none;
//     color: #fff;
//     padding-left:0.3rem;
//     padding-right:0.3rem;
//   }

// &:hover::after {
//     padding-left:0.3rem;
//     padding-right:0.3rem;
//     content: 'TV Guide';
// }
// `

const SearchButton = styled(Link)`
margin-right: 1rem;
&::after {
    width: 8rem;
    overflow:hidden;
    white-space: nowrap;
    border-radius:4px;
    text-decoration: none;
    color: #fff;
    padding-left:0.3rem;
    padding-right:0.3rem;
    content: 'Search...';
}
&:hover {
    border: 3px solid #ec1650
}
&:focus {
    border: 3px solid #ec1650
}
`
// &:hover {
//     width: 8rem;
//     -webkit-transition: width 1s;
//     transition: width .5s;
//     overflow:hidden;
//     white-space: nowrap;
//     border-radius:5px;
//     text-decoration: none;
//     color: #fff;
//     padding-left:0.3rem;
//     padding-right:0.3rem;
//   }

// &:hover::after {
//     padding-left:0.3rem;
//     padding-right:0.3rem;
//     content: 'Search...';
// }
// `

const NavButton = styled(Link)`
margin-right: 1rem;
&::after {
    width: 10rem;
    overflow:hidden;
    white-space: nowrap;
    border-radius:4px;
    text-decoration: none;
    color: #fff;
    padding-left:0.3rem;
    padding-right:0.3rem;
    content: 'Open menu';
}
&:hover {
    border: 3px solid #ec1650
}
&:focus {
    border: 3px solid #ec1650
}
`
// &:hover {
//     width: 10rem;
//     -webkit-transition: width 1s;
//     transition: width .5s;
//     overflow:hidden;
//     white-space: nowrap;
//     border-radius:5px;
//     text-decoration: none;
//     color: #fff;
//     padding-left:0.3rem;
//     padding-right:0.3rem;
//   }

// &:hover::after {
//     padding-left:0.3rem;
//     padding-right:0.3rem;
//     content: 'Open menu';
// }
// `

const NavBar = () => {
    const fullScreen = useSelector(state => state.fullScreen);
    const location = useLocation();
    const history = useHistory();
    let auth = useAuth();

    const { playingMode } = useParams();

    const redirect = (page) =>{
		setTimeout(()=>{
			history.push(page)
        },600)
	}

    window.JumpSearch = () => {
        console.log('【跳转】');
        redirect(`${location.pathname.split("?")[0]}/search/`)
    }

    return (
        <Nav className="navbar" style={{display : fullScreen ? "none" : ""}}>
            <div tabIndex={-1} className="container-fluid">
                <Link tabIndex={-1} className="navbar-brand" to="/">
                    <img src="/img/banner_w.png" alt="" height="20rem" className="d-inline-block align-top"/>
                </Link>
            </div>
            <ContainerButton>
                {auth.isAuth() && !location.pathname.includes("menu") && (
                <>
                    {/* {location.pathname.includes("live") && (<EPGButton to={`${location.pathname.split("?")[0]}tvguide/`}><i className={"fas fa-tv"}></i></EPGButton>)} */}
                    
                    <SearchButton to={{
                        pathname : `${location.pathname.split("?")[0]}search/`,
                        search: window.location.search,
                    }}><i className={"fas fa-search"}></i></SearchButton>

                    <CategoryButton to={{
                        pathname: `/${playingMode}/category/`,
                        search: window.location.search,
                    }}><i className={"fas fa-grip-lines"}></i></CategoryButton>
                    {/* <NavButton to={`menu/`}><i className="fas fa-ellipsis-v"></i></NavButton> */}
                </>)}
            </ContainerButton>
        </Nav>
    )
}

export default NavBar
